document.addEventListener('DOMContentLoaded', () => {
  const locationItems = document.querySelectorAll('.location-links-ul li');
  const viewMoreBtn = document.getElementById('viewMoreLocation');

  if (!locationItems.length || !viewMoreBtn) return;

  const MIN_VISIBLE_ITEMS = 8;
  let isExpanded = false;

  // Hide items beyond the minimum and set initial button text
  const initializeList = () => {
    locationItems.forEach((item, index) => {
      if (index < MIN_VISIBLE_ITEMS) {
        item.classList.remove('d-n');
        item.classList.add('d-b');
      } else {
        item.classList.remove('d-b');
        item.classList.add('d-n');
      }
    });

    // Initial button state
    updateButtonText();
  };

  // Update button text and aria attributes
  const updateButtonText = () => {
    if (isExpanded) {
      viewMoreBtn.textContent = 'View Less';
      viewMoreBtn.setAttribute('aria-expanded', 'true');
    } else {
      viewMoreBtn.textContent = 'View More';
      viewMoreBtn.setAttribute('aria-expanded', 'false');
    }
  };

  // Toggle visibility of hidden items
  const toggleItems = (e) => {
    e.preventDefault();

    isExpanded = !isExpanded;

    locationItems.forEach((item, index) => {
      if (index >= MIN_VISIBLE_ITEMS) {
        // Set stagger index for cascading animation
        item.style.setProperty('--item-index', (index - MIN_VISIBLE_ITEMS));
        
        // Toggle the hidden class
        item.classList.toggle('d-n');
      }
    });

    updateButtonText();
  };

  // Initialize on load
  initializeList();

  // Attach single event listener to button
  viewMoreBtn.addEventListener('click', toggleItems);
});